import { createSelector } from 'reselect';
import { denormalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { getDataEntities } from '@wix/da-shared-react/pkg/redux/entities/selectors';
import { deviationSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import { galleryFolderSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/folder';
import { DeviationSubmitPopupStoreSlice, InitResponse } from '../types';
import { reduxKey } from '../constants';

export function getSlice(state: any): DeviationSubmitPopupStoreSlice {
  if (!state[reduxKey]) {
    return {} as any;
  }
  return state[reduxKey];
}

export const getFormStatus = createSelector(getSlice, slice => slice.formStatus);

export const getUploadStatus = createSelector(getSlice, slice => slice.uploadStatus);

export const getNormalizedInitResponse = createSelector(getSlice, slice => slice.response);

const responseSchema = {
  deviation: deviationSchema,
  tiers: [deviationSchema],
  inTiers: [deviationSchema],
  galleries: [galleryFolderSchema],
  inGalleries: [galleryFolderSchema],
};

export const denormalizeResponse = (normalizedResponse, entities) => ({
  ...normalizedResponse,
  ...denormalize(normalizedResponse, responseSchema, entities),
});

export const getInitResponse = createSelector(
  getNormalizedInitResponse,
  getDataEntities,
  denormalizeResponse
);

export const getResponseDeviation = createSelector(
  getInitResponse,
  (response: InitResponse | undefined) => response?.deviation
);

export const getAllTierTags = createSelector(getSlice, slice => slice.tagsByTierId);

export const getTierTags = createSelector(
  [getAllTierTags, (state, tierId) => tierId],
  (tagsByTierId, tierId) => tagsByTierId?.[tierId]
);

export const getDefaultValues = createSelector(getSlice, slice => slice.defaultValues);

export const getIsBusyScheduling = createSelector(
  getSlice,
  slice => slice.scheduleStatus === 'busy'
);

export const getScheduleTimestamp = createSelector(getSlice, slice => slice.scheduleTimestamp);

export const getError = createSelector(getSlice, slice => slice.error);

export const getGroupDestinations = createSelector(getSlice, slice => slice.groupDestinations);

export const getPublishRequestStatus = createSelector(
  getSlice,
  slice => slice.publish?.requestStatus ?? 'idle'
);
